//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../Features/Features.StructureDesign.ContextAttributeBuilder.js";
import "../Features/Features.StructureDesign.FeatureSpreadsheetBuilder.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Features.js";
let d=[[[0,"AddAlignment",1,0],[1,"Alignment",0,"ScCollector",0],[0,"AlignmentType",1,0],[0,"AngularTolerance",1,0],[1,"AttachmentOffset",0,"Expression",0],[0,"AttachmentPointNormal",1,0],[1,"ContextAttribute",0,"Features.StructureDesign.ContextAttributeBuilder",0],[1,"Counts",0,"Expression",0],[0,"DistanceTolerance",1,0],[1,"FirstFaceSelect",0,"ScCollector",0],[1,"FlangeData",0,"Features.StructureDesign.FeatureSpreadsheetBuilder",0],[0,"GussetName",1,0],[1,"OffsetDistance",0,"Expression",0],[0,"OrientVector",1,"Direction",0],[0,"PickPointOnAttachment",1,0],[0,"PickPointOnReinforcement",1,0],[1,"PitchAngle",0,"Expression",0],[0,"PositionType",1,0],[1,"ReinforcementOffset",0,"Expression",0],[0,"ReinforcementPointNormal",1,0],[0,"ReverseAlignEdge",1,0],[0,"ReverseAttachmentOffsetFlange",1,0],[0,"ReverseFirstFace",1,0],[0,"ReverseFlange",1,0],[0,"ReverseReinforcementOffsetFlange",1,0],[0,"ReverseSecondFace",1,0],[1,"SecondFaceSelect",0,"ScCollector",0],[0,"ThicknessType",1,0]],[],[]];
SPLM.Features.StructureDesign.GussetBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.GussetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.GussetBuilder.AlignmentTypes = Object.freeze({
    "GussetPlate" : "GussetPlate", "LappedPlate" : "LappedPlate"});

SPLM.Features.StructureDesign.GussetBuilder.ThicknessTypes = Object.freeze({
    "BothSides" : "BothSides", "InnerSide" : "InnerSide", "OuterSide" : "OuterSide"});

SPLM.Features.StructureDesign.GussetBuilder.PositionTypes = Object.freeze({
    "Offset" : "Offset", "Center" : "Center", "AlignToEdge" : "AlignToEdge"});

export default SPLM;